import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { smallText, tones } from "./constants";

const styles = {
    icon: { width: 28, height: 28, borderRadius: 8 },
    count: { fontSize: 11, lineHeight: "18px", minWidth: 18, borderRadius: 9 },
};

const Section = ({ icon, title, description, count, tone, action, children }) => (
    <div className="mb-4">
        <div className="d-flex align-items-start mb-3">
            <span
                className="d-flex align-items-center justify-content-center flex-shrink-0 mr-2"
                style={{ ...styles.icon, ...tones[tone] }}
            >
                <FontAwesomeIcon icon={icon} size="sm" />
            </span>
            <div className="d-flex flex-column">
                <div className="d-flex align-items-center">
                    <span className="font-weight-bold mr-2">{title}</span>
                    <span className="text-center font-weight-bold px-1" style={{ ...styles.count, ...tones[tone] }}>
                        {count}
                    </span>
                </div>
                <span className="text-muted" style={smallText}>{description}</span>
            </div>
        </div>
        {action}
        <div className="d-flex flex-column" style={{ gap: 8 }}>
            {children}
        </div>
    </div>
);

export default Section;
